import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Cell } from '../../base/styled';

import LineChartWidget from '../../widgets/LineChartWidget';
import NumberWidget from '../../widgets/NumberWidget';

const StatusWidget = styled.div`
  height: 50px;
  padding-top: 15px;
  color: ${(props) => {
    if (props.success !== null) {
      if (props.success) {
        return props.theme.brandSuccess;
      }
      return props.theme.brandDanger;
    }
    return props.theme.grayLighter;
  }}
`;

const StatusWidgetTitle = styled.span`
  font-size: 1.0em;
`;

const StatusWidgetMessage = styled.span`
  font-size: 1.2em;
`;

const Epg = (props) => {

  const {
    title = '',
    results: {
      error = null,
      data: {
        breakout0 = null,
        breakout1 = null,
        breakout2 = null,
        breakout3 = null,
        breakout4 = null,
        breakout5 = null,
        timeline,
        TOTAL: matchTotal = null,
        INFO: matchInfo = null,
        DEBUG: matchDebug = null,
      } = {},
    } = {},
  } = props;

  let message = 'UNKNOWN';
  let success = null;
  if (matchTotal && matchTotal.data) {
    if (matchTotal.data.value) {
      message = 'ACTIVE';
      success = true;
    } else {
      message = 'IDLE';
      success = false;
    }
  }

  return (
    <div className="dashboard">
      <Grid columns={4} rows="90px 2fr 1fr 1fr" alignContent="stretch" height="inherit">
        <Cell width={3}>
          <h1>{title}</h1>
        </Cell>
        <Cell>
          <StatusWidget success={success}>
            <StatusWidgetTitle>STATUS:&nbsp;&nbsp;</StatusWidgetTitle>
            <StatusWidgetMessage>{message}</StatusWidgetMessage>
          </StatusWidget>
        </Cell>
        <Cell width={3}>
          <LineChartWidget input={{ error, data: timeline }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: matchTotal }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: breakout0 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: breakout1 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: breakout2 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: matchInfo }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: breakout3 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: breakout4 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: breakout5 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: matchDebug }} />
        </Cell>
      </Grid>
    </div>
  );
};

Epg.defaultProps = null;

Epg.propTypes = {
  title: PropTypes.string,
  results: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      breakout0: NumberWidget.dataPropType,
      breakout1: NumberWidget.dataPropType,
      breakout2: NumberWidget.dataPropType,
      breakout3: NumberWidget.dataPropType,
      breakout4: NumberWidget.dataPropType,
      breakout5: NumberWidget.dataPropType,
      timeline: LineChartWidget.dataPropType,
      TOTAL: NumberWidget.propTypes,
      INFO: NumberWidget.propTypes,
      DEBUG: NumberWidget.propTypes,
    }),
  }),
};

export default Epg;
